import { render, staticRenderFns } from "./wxCallBack.vue?vue&type=template&id=5927c3ec&scoped=true"
import script from "./wxCallBack.vue?vue&type=script&lang=js"
export * from "./wxCallBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927c3ec",
  null
  
)

export default component.exports